import {
  redux_getAllAdminUsers,
  redux_getAllUsers,
  redux_getAdminUser,
  redux_updateAdminUser,
  redux_createAdminUser,
  redux_deleteAdminUser,
  redux_updateAdminRole,
  redux_adminManagementActionStarts,
  redux_adminManagementActionErrors,
} from '../../core/data/redux/modules/adminManagement/actions';
import { Dispatch } from 'redux';
import { makeApiRequest } from '../../utils/api-utils';

// Get all admin users
export const getAllAdminUsers = () => async (dispatch: any) => {
  dispatch(redux_adminManagementActionStarts());
  try {
    const response = await makeApiRequest(`/user/admin/get-all-admin-users`);
    const responseDto = response;
    if (responseDto.error) {
      dispatch(redux_adminManagementActionErrors(responseDto.error));
    } else {
      dispatch(redux_getAllAdminUsers(responseDto.data));
    }
  } catch (error) {
    dispatch(
      redux_adminManagementActionErrors(
        (error as any)?.message || 'Error fetching admin users',
      ),
    );
  }
};

// Get all users
export const getAllUsers = () => async (dispatch: any) => {
  dispatch(redux_adminManagementActionStarts());
  try {
    const response = await makeApiRequest(`/user/admin/get-all`);
    const responseDto = response;
    if (responseDto.error) {
      dispatch(redux_adminManagementActionErrors(responseDto.error));
    } else {
      dispatch(redux_getAllUsers(responseDto.data));
    }
  } catch (error) {
    dispatch(
      redux_adminManagementActionErrors(
        (error as any)?.message || 'Error fetching all users',
      ),
    );
  }
};

// Get single admin user
export const getAdminUser = (id: string) => async (dispatch: any) => {
  dispatch(redux_adminManagementActionStarts());
  try {
    const response = await makeApiRequest(`/user/admin/get-all`);
    const responseDto = response;
    if (responseDto.error) {
      dispatch(redux_adminManagementActionErrors(responseDto.error));
    } else {
      const adminUser = responseDto.data.find((user: any) => user.id === id);
      dispatch(redux_getAdminUser(adminUser));
    }
  } catch (error) {
    dispatch(
      redux_adminManagementActionErrors(
        (error as any)?.message || 'Error fetching admin user',
      ),
    );
  }
};

// Create admin user
export const createAdminUser = (
  adminData: any,
  setModalOpen?: (value: boolean) => void,
) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(redux_adminManagementActionStarts());

      const response = await makeApiRequest(`/user/admin/create`, {
        method: 'POST',
        body: JSON.stringify(adminData),
      });

      const responseDto = response;

      if (!responseDto.error) {
        dispatch(redux_createAdminUser(responseDto));
        if (setModalOpen) {
          setModalOpen(false);
        }
      } else {
        dispatch({
          type: 'ADMIN_MANAGEMENT_ACTION_ERRORS',
          payload: (responseDto as any)?.message,
        });
      }
    } catch (error) {
      dispatch({ 
        type: 'ADMIN_MANAGEMENT_ACTION_ERRORS', 
        payload: 'An error occurred' 
      });
    }
  };
};

// Update admin user
export const updateAdminUser = (
  accessToken: string,
  adminData: any,
  setModalOpen?: (value: boolean) => void,
  isSoftDelete = false,
) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(redux_adminManagementActionStarts());

      const updateData = {
        ...adminData,
        is_active: !isSoftDelete,
        is_deleted: isSoftDelete,
      };

      const response = await makeApiRequest(`/user/admin/update`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(updateData),
      });

      const responseDto = response;

      if (!responseDto.error) {
        dispatch(redux_updateAdminUser(responseDto));
        if (setModalOpen) {
          setModalOpen(false);
        }
      } else {
        dispatch({
          type: 'ADMIN_MANAGEMENT_ACTION_ERRORS',
          payload: (responseDto as any)?.message,
        });
      }
    } catch (error) {
      dispatch({ 
        type: 'ADMIN_MANAGEMENT_ACTION_ERRORS', 
        payload: 'An error occurred' 
      });
    }
  };
};

// Update admin role
export const updateAdminRole = (
  roleData: any,
  setModalOpen?: (value: boolean) => void,
) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(redux_adminManagementActionStarts());

      const response = await makeApiRequest(`/user/admin/update-role`, {
        method: 'PUT',
        body: JSON.stringify(roleData),
      });

      const responseDto = response;

      if (!responseDto.error) {
        dispatch(redux_updateAdminRole(responseDto));
        if (setModalOpen) {
          setModalOpen(false);
        }
      } else {
        dispatch({
          type: 'ADMIN_MANAGEMENT_ACTION_ERRORS',
          payload: (responseDto as any)?.message,
        });
      }
    } catch (error) {
      dispatch({ 
        type: 'ADMIN_MANAGEMENT_ACTION_ERRORS', 
        payload: 'An error occurred' 
      });
    }
  };
};

// Delete admin user
export const deleteAdminUser = (
  accessToken: string,
  adminId: string,
  setModalOpen?: (value: boolean) => void,
) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(redux_adminManagementActionStarts());

      const response = await makeApiRequest(`/user/admin/delete/${adminId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const responseDto = response;

      if (!responseDto.error) {
        dispatch(redux_deleteAdminUser(responseDto));
        if (setModalOpen) {
          setModalOpen(false);
        }
      } else {
        dispatch({
          type: 'ADMIN_MANAGEMENT_ACTION_ERRORS',
          payload: (responseDto as any)?.message,
        });
      }
    } catch (error) {
      dispatch({ 
        type: 'ADMIN_MANAGEMENT_ACTION_ERRORS', 
        payload: 'An error occurred' 
      });
    }
  };
}; 